import { Space, Typography } from '@sravni/react-design-system';

import { formatMoney } from '@src/helpers/formatMoney';
import { DAYS_IN_WEEK } from 'entities/FullDeal/config';
import { formatDateWithOffset } from 'entities/FullDeal/lib';

import {
  LONG_TERM_FIRST_RANGE_COEFFICIENT,
  LONG_TERM_SECOND_RANGE_COEFFICIENT,
} from '../FullDealEntryPointFormCalculations/FullDealEntryPointFormCalculations.config';
import { calculateLongDebt, calculateShortDebt } from '../FullDealEntryPointFormCalculations/lib';

import styles from './FullDealCalculationsMinimal.module.scss';

interface Props {
  term: number;
  amount: number;
}
export function FullDealCalculatorCalculationsMinimal({ term, amount }: Props) {
  const withoutOverpayment = term < 22;
  const isShowShortDebt = term < 34;

  const amountWithOverpayment = calculateShortDebt(amount, term);
  const repaymentDate = formatDateWithOffset(term - 1);

  if (isShowShortDebt)
    return (
      <Space direction="row" align="center" size={8}>
        <div className={styles.badge}>0%</div>

        <Space direction="column" size={4}>
          <Typography.Text>К возврату {repaymentDate}</Typography.Text>
          <Space direction="row" size={4}>
            <Typography.Text strong size={15 as any}>
              {withoutOverpayment ? formatMoney(amount) : formatMoney(amountWithOverpayment)}
            </Typography.Text>
            {withoutOverpayment && (
              <Typography.Text size={14} className={styles.decoratedText}>
                {formatMoney(amountWithOverpayment, { withSymbol: false })}
              </Typography.Text>
            )}
          </Space>
        </Space>
      </Space>
    );

  const termByWeeks = Math.round(term / DAYS_IN_WEEK);
  const calculations = calculateLongDebt(
    amount,
    termByWeeks,
    amount > 70_000 ? LONG_TERM_SECOND_RANGE_COEFFICIENT : LONG_TERM_FIRST_RANGE_COEFFICIENT,
  );

  return (
    <Space direction="row" align="center">
      <Space direction="column" size={2}>
        <Typography.Text>Платеж раз в 2 недели</Typography.Text>
        <Typography.Text as="span" strong size={15 as any}>
          {formatMoney(calculations)}
        </Typography.Text>
      </Space>
      {/* <Space direction="column" size={2}>
        <Typography.Text size={12}>Погасить до</Typography.Text>
        <Typography.Text size={14} strong className={styles.alignRight}>
          {repaymentDate}
        </Typography.Text>
      </Space> */}
    </Space>
  );
}
